// extracted by mini-css-extract-plugin
export default {"chat-container":"ChatContainer_chat-container__yadHK","messages":"ChatContainer_messages__CEk0R","placeholder":"ChatContainer_placeholder__c7i74"};